/* TODO: t() */
/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useState } from 'react';
import { View, StyleSheet } from 'react-native';

import { useShowMessage } from '../../core-ui';
import { postJSON } from '../../support/Fetch';
import { User } from '../../types/shared/User';

import {
  Button,
  FormField,
  Text,
  TextInputPassword,
  SubmitButton,
  Form,
  Modal,
} from '../uiold';
import { themeColors } from '../uiold/Constants';
import LoadingIndicator from '../uiold/LoadingIndicator';

type PasswordChangeDialogProps = {
  isOpen: boolean;
  onClosePress: () => void;
  user: User;
};

export function PasswordChangeDialog(props: PasswordChangeDialogProps) {
  let [confirmPassword, setConfirmPassword] = useState('');
  let [currentPassword, setCurrentPassword] = useState('');
  let [newPassword, setNewPassword] = useState('');
  let [isLoading, setIsLoading] = useState(false);

  let { isOpen, onClosePress, user } = props;

  const showMessage = useShowMessage();

  const onSubmit = () => {
    let errorText = '';
    if (!user) {
      return;
    }
    if (currentPassword.length === 0) {
      errorText = 'Please enter your current password.';
    } else if (newPassword.length === 0) {
      errorText = 'Please enter a new password.';
    } else if (confirmPassword.length === 0) {
      errorText = 'Please re-enter your new password.';
    } else if (newPassword !== confirmPassword) {
      errorText = 'New password does not match.';
    }
    if (errorText) {
      showMessage('error', errorText);
      return;
    }

    setIsLoading(true);
    postJSON(
      '/api/password',
      { id: user.id, current: currentPassword, password: newPassword },
      (error, data) => {
        if (data && typeof data.error === 'string') {
          showMessage('error', data.error);
        } else if (error) {
          showMessage('error', error.message);
        } else if (data.success === true) {
          onClosePress();
          showMessage('success', 'Password changed successfully');
        } else {
          showMessage('error', 'Unknown error');
        }
        setIsLoading(false);
      },
    );
  };

  return user == null ? null : (
    <Modal
      isVisible={isOpen}
      title="Change Password"
      onClose={() => onClosePress()}
    >
      <Form onSubmit={onSubmit}>
        <Modal.Body>
          <FormField
            render={(id) => (
              <View style={styles.rowDiv}>
                <Text
                  type="label"
                  style={styles.textLabel}
                  accessibilityRole="label"
                  htmlFor={id}
                >
                  Current Password
                </Text>
                <TextInputPassword
                  id={id}
                  autoFocus
                  skipFirstCheck
                  value={currentPassword}
                  checkPassword={(password) => !!password}
                  errorMessage="Please enter your current password."
                  backgroundColor={themeColors.lightGrey}
                  onChangeText={(value: string) => {
                    setCurrentPassword(value);
                  }}
                />
              </View>
            )}
          />
          <FormField
            render={(id) => (
              <View style={styles.rowDiv}>
                <Text
                  type="label"
                  style={styles.textLabel}
                  accessibilityRole="label"
                  htmlFor={id}
                >
                  New Password
                </Text>
                <TextInputPassword
                  id={id}
                  skipFirstCheck
                  value={newPassword}
                  backgroundColor={themeColors.lightGrey}
                  errorMessage="Minimum length 8; must include uppercase, lowercase and number."
                  onChangeText={(value: string) => setNewPassword(value)}
                />
              </View>
            )}
          />
          <FormField
            render={(id) => (
              <View style={styles.rowDiv}>
                <Text
                  type="label"
                  style={styles.textLabel}
                  accessibilityRole="label"
                  htmlFor={id}
                >
                  Confirm New Password
                </Text>
                <TextInputPassword
                  id={id}
                  skipFirstCheck
                  value={confirmPassword}
                  backgroundColor={themeColors.lightGrey}
                  errorMessage="New password does not match."
                  checkPassword={(password) => password === newPassword}
                  onChangeText={(value: string) => setConfirmPassword(value)}
                />
              </View>
            )}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            title="Cancel"
            onPress={() => props.onClosePress()}
            style={styles.cancelButton}
          />
          {isLoading === true ? (
            <LoadingIndicator />
          ) : (
            <SubmitButton title="Save" />
          )}
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

let styles = StyleSheet.create({
  rowDiv: {
    marginBottom: 20,
  },
  textLabel: {
    color: themeColors.darkGrey,
    marginTop: 10,
  },
  cancelButton: {
    backgroundColor: themeColors.transparent,
    borderWidth: 0,
  },
});
